import Downshift from "downshift";
import debounce from "lodash/debounce";
import inputStyles from "plos/src/components/forms/Input/Input.module.css";
import searchFieldStyles from "plos/src/components/forms/SearchField/SearchField.module.css";
import SearchIcon from "plos/src/img/icons/search.svg?react";
import { useState } from "react";
import { entryList, listItem } from "./entrySelector.css";

interface IEntry {
  entry: number;
  player_name: string;
  entry_name: string;
}

interface IEntrySelectorProps {
  entries: IEntry[];
  handleChange: (selectedItem: any) => void;
  searchChange: (value: string) => any;
}

const EntrySelector = ({
  entries,
  handleChange,
  searchChange,
}: IEntrySelectorProps) => (
  <Downshift
    onChange={(selection) => handleChange(Number(selection.entry))}
    onInputValueChange={debounce(searchChange, 400)}
    itemToString={(item) => (item ? item.player_name : "")}
  >
    {({ getInputProps, getItemProps, getLabelProps, getMenuProps, isOpen }) => (
      <div>
        <div className={searchFieldStyles.searchFieldInputWrapper}>
          <input
            type="search"
            className={inputStyles.searchInput}
            {...getInputProps()}
            {...getLabelProps()}
          />
          <SearchIcon className={searchFieldStyles.searchIcon} />
        </div>
        <ul {...getMenuProps()} className={entryList}>
          {isOpen
            ? entries.map((item, index) => (
                <li
                  className={listItem}
                  {...getItemProps({
                    key: item.entry,
                    index,
                    item,
                  })}
                >
                  {item.player_name} ({item.entry_name})
                </li>
              ))
            : null}
        </ul>
      </div>
    )}
  </Downshift>
);

interface IProps {
  excluded?: number[];
  handleChange: (selectedItem: any) => void;
  leagueId: number;
}

const EntrySelectorWrapper = ({
  excluded = [],
  handleChange,
  leagueId,
}: IProps) => {
  const [entries, setEntries] = useState<IEntry[]>([]);
  const [lastSearch, setLastSearch] = useState("");

  const searchChange = async (value: string) => {
    // If the search term has been cleared, clear any state
    if (!value.length) {
      handleChange(0);
      setEntries([]);
      setLastSearch("");
      return;
    }

    // We are only interested in first name searches
    const searchMatches = value.match(/^(.*?)(?: |$)/);
    if (searchMatches && searchMatches[1] !== lastSearch) {
      const response = await fetch(
        `/api/league/${leagueId}/search-entries/?search=${encodeURIComponent(
          searchMatches[1],
        )}`,
      );
      setLastSearch(searchMatches[1]);
      if (response.ok) {
        const newEntries: IEntry[] = await response.json();
        setEntries(newEntries.filter((e) => excluded.indexOf(e.entry) === -1));
      }
    }
  };

  return (
    <EntrySelector
      entries={entries}
      handleChange={handleChange}
      searchChange={searchChange}
    />
  );
};

export default EntrySelectorWrapper;
